module.exports = __webpack_public_path__ + "media/ko_kr_s4_MinJung.888b4947.mp3";